// Texte der Aktivitäten-Listen, rein (mit node --test prüfbar, deshalb ohne Import aus anderen Dateien).

/** Anruf-Ergebnisse wie im Verlauf der Lead-Seite (texte.ts `DISPOSITION`), hier in der Reihenfolge der Filterauswahl. */
export const ERGEBNISSE: { wert: string; label: string }[] = [
  { wert: "answered", label: "Angenommen" },
  { wert: "no-answer", label: "Nicht angenommen" },
  { wert: "busy", label: "Besetzt" },
  { wert: "vm-answer", label: "Mailbox" },
  { wert: "vm-left", label: "Auf Mailbox gesprochen" },
  { wert: "blocked", label: "Blockiert" },
  { wert: "error", label: "Fehler" },
  { wert: "abandoned", label: "Abgebrochen" },
];

export function ergebnisText(wert: string | null | undefined): string {
  if (!wert) return "";
  return ERGEBNISSE.find((e) => e.wert === wert)?.label ?? wert;
}

/** Rot für Gespräche, die nicht zustande kamen, grün für angenommene, neutral für Mailbox und sonst. */
export function ergebnisTon(wert: string | null | undefined): "ok" | "fehlt" | "neutral" {
  if (wert === "answered") return "ok";
  if (wert === "no-answer" || wert === "busy" || wert === "blocked" || wert === "error" || wert === "abandoned") return "fehlt";
  return "neutral";
}

const STATUS: Record<string, string> = {
  // E-Mail
  sent: "Gesendet",
  inbox: "Eingegangen",
  draft: "Entwurf",
  scheduled: "Geplant",
  outbox: "Wird gesendet",
  error: "Fehler",
  // Anruf, der gerade angelegt wurde (Wählliste)
  created: "Angelegt",
  // SMS
  delivered: "Zugestellt",
  failed: "Fehlgeschlagen",
  received: "Empfangen",
  // Meeting
  upcoming: "Anstehend",
  "in-progress": "Läuft",
  completed: "Abgeschlossen",
  canceled: "Abgesagt",
  "declined-by-lead": "Vom Kunden abgelehnt",
  "declined-by-org": "Von uns abgelehnt",
  // Custom Activity
  published: "Veröffentlicht",
};

export function statusText(wert: string | null | undefined): string {
  if (!wert) return "";
  return STATUS[wert] ?? wert;
}

/** „Max Muster <max@firma.de>“ -> „Max Muster“; nur eine Adresse bleibt die Adresse. */
export function absenderName(roh: string | null | undefined): string {
  const text = (roh ?? "").trim();
  if (!text) return "";
  const m = /^"?([^"<]*?)"?\s*<([^>]+)>$/.exec(text);
  if (!m) return text;
  return m[1].trim() || m[2].trim();
}

/** Das Gegenüber einer Mail: bei ausgehenden der erste Empfänger (mit „+n“), bei eingehenden der Absender. */
export function gegenueber(richtung: string | null | undefined, von: string | null | undefined, an: readonly string[] | null | undefined): string {
  if (richtung === "eingehend") return absenderName(von);
  const empfaenger = an ?? [];
  if (!empfaenger.length) return absenderName(von);
  return empfaenger.length > 1 ? `${empfaenger[0]} +${empfaenger.length - 1}` : empfaenger[0];
}

/** Vorname für die schmale Spalte „Mitarbeiter“ („Simon Lempert“ -> „Simon“). */
export function vorname(name: string | null | undefined): string {
  const teile = (name ?? "").trim().split(/\s+/).filter(Boolean);
  return teile[0] ?? "";
}
